// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ReportPayment__Widget label[data-v-78f2e296] {\n  display: flex;\n}\n.ReportPayment__Widget label span[data-v-78f2e296] {\n    font-weight: 600;\n    padding-left: 5px;\n}\n.ReportPayment__Widget label span[data-v-78f2e296]::after {\n      content: ':';\n}\n.ReportPayment__Widget .payable[data-v-78f2e296] {\n  margin-top: 10px;\n  color: #5a5a5a;\n  border-radius: 3px;\n  padding: 2px 10px;\n  background-color: #ffd17e;\n}\n", ""]);
// Exports
module.exports = exports;
